// @flow
import React from 'react'
import classnames from 'classnames'

import AbstractFormField from './AbstractFormField'

// types
import type { DefaultFormFieldType } from './AbstractFormField'

type NumberProps = DefaultFormFieldType & {
  id: string,
  max?: number,
  min?: number,
  precision?: number,
  step?: number,
  tabIndex: string,
  value: number | string,
}

export default class Number extends AbstractFormField<NumberProps, {}> {
  ref = React.createRef()

  static defaultProps = {
    tabIndex: null,
  }

  validateField = (value, props) => {
    let error = {}
    if (props.required && (!value || value === null || value === '')) {
      error = {
        error_type: 'REQUIRED',
        item_index: 2
      }
      props.onErrorChange(props.name, error)
      return false
    }
    props.onErrorChange(props.name, {})
    return true
  }

  validate = (value: string | number) => this.validateField(value, this.props)

  handleOnChange = (event: { target: { value: string | number } }) => {
    this.props.onChange(this.props.id, event.target.value)
  }

  handleOnBlur = () => {
    this.validate(this.props.value)
    this.onBlur()
    let value = parseInt(this.props.value)
    if (!this.props.value) {
      this.props.onBlur(this.props.name, '')
      return
    }
    else if (typeof(this.props.min) !== 'undefined' && value < this.props.min) {
      this.props.onBlur(this.props.name, this.props.min)
      this.changeValue(this.props.min)
      return
    }
    else if (typeof(this.props.max) !== 'undefined' && value > this.props.max) {
      this.props.onBlur(this.props.name, this.props.max)
      this.changeValue(this.props.max)
      return
    }

    const step = this.props.step ? this.props.step : 1
    value = (Math.round(this.props.value / step) * step)

    if (this.props.min && value < this.props.min) {
      this.props.onBlur(this.props.name, this.props.min)
      this.changeValue(this.props.min)
    } else if (this.props.max && value > this.props.max) {
      this.props.onBlur(this.props.name, this.props.max)
      this.changeValue(this.props.max)
    } else {
      value = value.toString()
      this.props.onBlur(this.props.name, value)
      this.changeValue(value)
    }
  }

  changeValue = (value: number) => {
    this.props.onChange(this.props.id, value)
  }

  render() {

    if (this.props.textMode) {
      return <span>{this.props.value}</span>
    }

    let additionalAttrs = {}

    if (typeof(this.props.min) !== 'undefined') {
      additionalAttrs['min'] = this.props.min
    }
    if (typeof(this.props.max) !== 'undefined') {
      additionalAttrs['max'] = this.props.max
    }
    if (this.props.step) {
      additionalAttrs['step'] = this.props.step
    }

    const classes = ['form-control']
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    return (
      <div>
        <input
          className={classnames(classes)}
          data-hj-whitelist
          id={this.props.id}
          name={this.props.name}
          onBlur={this.handleOnBlur}
          onChange={this.handleOnChange}
          readOnly={!this.props.enabled}
          ref={this.ref}
          tabIndex={this.props.tabIndex}
          type='number'
          value={typeof this.props.value === 'undefined' || this.props.value === null ? '' : this.props.value}
          {...additionalAttrs}
        />
        {this.hasErrors() && !this.isPristine() &&
        <div className='invalid-tooltip mt-0'><span>{this.getErrorText()}</span></div>
        }
      </div>
    )
  }
}
